import styled from 'styled-components'

import { Search } from '../../../components/Icons/components'
import { btnSecondaryBg, media, white } from '../../../utils/style-utils'

interface Props {
  isActive: boolean
}

export const StyledSearchIcon = styled(Search).withConfig({
  shouldForwardProp: (prop) => !prop.includes('isActive'),
})<Props>`
  height: 2.5em;
  ${({ isActive }: Props) => (isActive ? `fill:${btnSecondaryBg}` : `fill:${white}`)};

  ${media.md`
    height: 2em;
  `}
`
